import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { getGenericPanelPadding } from '../../../styles';
export const panelFooterStyles = ({ theme, $withBackground, $withBorderRadius, }) => css `
	margin-top: auto;
	padding-bottom: ${pxToRem(theme.spacing[300])};

	${getGenericPanelPadding(['right', 'left'])}

	${$withBackground &&
    css `
		background-color: ${theme.colors.light.bgReceiptPrice};

		${$withBorderRadius &&
        css `
			border-bottom-left-radius: ${pxToRem(Number(theme.borderRadius.m) - Number(theme.borderWidth['2']))};
			border-bottom-right-radius: ${pxToRem(Number(theme.borderRadius.m) - Number(theme.borderWidth['2']))};
		`}
	`}

	p:last-child {
		margin: 0;
	}
`;
export const PanelFooterContainer = styled.footer `
	${panelFooterStyles}
`;
//# sourceMappingURL=panel-footer.styled.js.map